import React, { Component } from "react";

class PlayWithUs extends Component {
    render() {

        const baseballPart = (
            <div className="col-lg-6 col-md-8 mb-40">
                <div className="block text-center pr-0 pr-lg-5">
                    <h4 className="quote-text text-dark font-w-600">Categoria U12 (da 9 a 12 anni)</h4>
                    <p>
                        I ragazzi imparano i fondamentali e partecipano a un campionato regionale.

                        <p> ALLENAMENTI: LUNERDI, MERCOLEDI E GIOVEDI 17:30 - 19:30, CAMPO: MEZZETTA</p>

                    </p>
                    <h4 className="quote-text text-dark font-w-600">Categoria U15 (da 13 a 15 anni)</h4>
                    <p>
                        I ragazzi partecipano a un campionato regionale di categoria.
                        <p>ALLENAMENTI - MARTEDI, GIOVEDI E VENERDI 18:00 - 20:00, CAMPO: CESARE VITA</p>
                    </p>
                    <h4 className="quote-text text-dark font-w-600">Serie C</h4>
                    <p >
                        La categoria di rifinitura, trampolino di lancio per le Seniores.
                        <p>ALLENAMENTI: LUNEDI, MERCOLEDI E GIOVEDI 18:00 - 20:00, CAMPO: CESARE VITA</p>
                    </p>
                </div>
            </div>
        );

        const softballPart = (
            <div className="col-lg-6 col-md-10 mb-40">
                <div className='block text-center mt-5 mt-lg-0'>
                    <h4 className="quote-text text-dark font-w-600">Categoria U15 (da 13 a 15 anni)</h4>
                    <p >
                        Per consolidare la conoscenza del gioco. La squadra partecipa a un campionato regionale.
                        <p>ALLENAMENTI: MARTEDI, MERCOLEDI E VENERDI 17:00 - 19:00, CAMPO: MEZZETTA</p>
                    </p>
                    <h4 className="quote-text text-dark font-w-600">Categoria U18 (da 15 a 18 anni)</h4>
                    <p >
                        La categoria di rifinitura, trampolino di lancio per le Seniores.
                        <p>ALLENAMENTI: MARTEDI, MERCOLEDI E VENERDI 17:00 - 19:00, CAMPO: MEZZETTA</p>
                    </p>
                    <h4 className="quote-text text-dark font-w-600">Serie B</h4>
                    <p>
                        <p>ALLENAMENTI: MERCOLEDI E VENERDI 19:45 - 21:45, CAMPO: CESARE VITA</p>
                    </p>
                </div>
            </div>
        )

        return (
            <section className="section bg-light-gray" id="trainingTimetable">
                <div className="container">
                    <div className="row justify-content-center align-items-center">
                        <div className="col-lg-6 col-md-8 text-center">
                            <h2 className="section-heading h1 text-dark mb-30">Vieni A Giocare Con Noi</h2>
                            <p className="mb-40">
                                PER PROVARE E' SUFFICIENTE PRESENTARSI IN SEGRETERIA 15 MINUTI PRIMA.
                                <p className="quote-text text-dark font-w-600">DUE SETTIMANE DI PROVA GRATUITE.
                                </p>
                            </p>

                        </div>
                        <div className="row justify-content-center align-items-center">
                            <div className="col-lg-6 col-md-8">
                                <div className="col-md-12 text-center">
                                    <h2 className="section-heading h1 text-dark mt-15">Baseball</h2>
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-8">
                                <div className="col-md-12 text-center">
                                    <h2 className="section-heading h1 text-dark mt-15">Softball</h2>
                                </div>

                            </div>
                            <div className="col-lg-6 col-md-8 text-center">
                                <h4 className="quote-text text-dark font-w-600">Minibaseball (da 6 a 8 anni)</h4>
                                <p>
                                    Per Imparare I fondamentali del baseball e softball divertendosi.
                                    ALLENAMENTI: MERCOLEDI E VENERDI 17:30 - 19:00. CAMPO: MEZZETTA
                                </p>
                                <h4 className="quote-text text-dark font-w-600">Non vedenti</h4>
                                <p>
                                    ALLENAMENTI: VENERDI 17:00 - 17:30, CAMPO: MEZZETTA
                                </p>
                            </div>
                        </div>
                        <div className="row justify-content-center align-items-center">
                            {baseballPart}
                            {softballPart}
                        </div>
                        <div className="mb-40 justify-content-center">
                            <h4 className="text-dark">
                                Arriva preparato, scarica e completa i seguenti moduli:</h4>
                            <div className="text-center">
                                <a href="/assets/downloads/Autocertificazione_temporanea_per_minore.pdf" download>Liberatoria</a>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}

export default PlayWithUs;